/**
 * What "there is no value here" looks like, declared once.
 *
 * A blank cell is ambiguous: the reader cannot tell an absent value from a
 * column that failed to render. One word, used everywhere, removes that
 * doubt and keeps the tables reading alike.
 *
 * It is the word "None", not a dash. A lone punctuation mark asks the reader
 * to decode it; a word says what it means, and it survives being read aloud
 * by a screen reader.
 *
 * Kept in a module of its own, with no JSX, so the pure view-model helpers
 * can use the same constant the components render.
 */

export const EMPTY_CELL = 'None';

/**
 * What "this document has no such field" looks like, in an audit diff.
 *
 * Deliberately NOT the same word as an empty cell. A stored `null` already
 * renders as `null`, so marking a missing key as "None" would claim the
 * record holds a value it does not have. This says the key is absent.
 */
export const ABSENT_FIELD = '(absent)';
